module.exports = __webpack_public_path__ + "img/airdrop-migrate-contract.046b87e0.png";